import React from 'react'

const IconActivity = ({fillColor, style}) => {
  return (
   <svg xmlns="http://www.w3.org/2000/svg" className={'icon ' + fillColor} style={style} viewBox="0 -960 960 960">
      <path d="m296-348.46 122-121.23 80 80 162-161.77V-460h40v-160H540v40h91.46L498-446.54l-80-80L268.46-376 296-348.46ZM224.62-160q-27.62 0-46.12-18.5Q160-197 160-224.62v-510.76q0-27.62 18.5-46.12Q197-800 224.62-800h510.76q27.62 0 46.12 18.5Q800-763 800-735.38v510.76q0 27.62-18.5 46.12Q763-160 735.38-160H224.62Zm0-40h510.76q9.24 0 16.93-7.69 7.69-7.69 7.69-16.93v-510.76q0-9.24-7.69-16.93-7.69-7.69-16.93-7.69H224.62q-9.24 0-16.93 7.69-7.69 7.69-7.69 16.93v510.76q0 9.24 7.69 16.93 7.69 7.69 16.93 7.69ZM200-760v560-560Z"/>
   </svg>
  )
}
export default IconActivity
